import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      console.log('Attempting login to:', api.defaults.baseURL);
      const res = await api.post('/auth/login', { email, password });
      console.log('Login successful');
      localStorage.setItem('token', res.data.token);
      navigate('/');
    } catch (err) {
      console.error('Login failed:', err);
      console.error('Error details:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        baseURL: api.defaults.baseURL
      });
      
      let errorMsg = 'Failed to connect to server.';
      
      if (err.code === 'ECONNABORTED') {
        errorMsg = 'Request timed out. Please check your internet connection.';
      } else if (err.code === 'ERR_NETWORK') {
        errorMsg = `Cannot reach server at ${api.defaults.baseURL}. Please check your internet connection.`;
      } else if (err.response) {
        errorMsg = err.response.data?.message || `Server error: ${err.response.status}`;
      } else if (err.request) {
        errorMsg = `No response from server. Check if ${api.defaults.baseURL} is accessible.`;
      } else {
        errorMsg = err.message || 'An unexpected error occurred.';
      }
      
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-md-row vh-100">
      {/* Left: Full Height Image */}
      <div className="d-none d-md-block col-md-6 p-0">
        <img
          src="/assets/login-image.png"
          alt="Login Visual"
          className="img-fluid h-100 w-100"
          style={{ objectFit: 'cover', borderTopRightRadius: '2rem', borderBottomRightRadius: '2rem' }}
        />
      </div>

      {/* Right: Login Form */}
      <div className="col-12 col-md-6 d-flex align-items-center justify-content-center p-4">
        <div className="w-100" style={{ maxWidth: '400px' }}>
          <div className="text-center mb-4">
            <img src="/assets/macroai-logo.png" alt="Macro.ai" style={{ height: '100px' }} />
          </div>
          <h3 className="text-center mb-3">Login to Macro.ai</h3>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                id="email"
                type="email"
                className="form-control"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                id="password"
                type="password"
                className="form-control"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="mb-3 text-end">
              <a href="/forgot-password" className="text-decoration-none small">Forgot password?</a>
            </div>
            <button type="submit" className="btn btn-success w-100 mb-3" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
            <div className="text-center">
              <span className="small">Don't have an account? <a href="/register">Sign up now</a></span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
